export enum CompanyAnalystNotesAndNewsBlock {
  Root = 'CompanyAnalystNotesAndNews',
}
